import { render, staticRenderFns } from "./sku_init.vue?vue&type=template&id=12c3053a&scoped=true&"
import script from "./sku_init.vue?vue&type=script&lang=js&"
export * from "./sku_init.vue?vue&type=script&lang=js&"
import style0 from "./sku_init.vue?vue&type=style&index=0&id=12c3053a&scoped=true&lang=less&"
import style1 from "./sku_init.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12c3053a",
  null
  
)

export default component.exports